/* istanbul ignore file */
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { CoreModule } from "@core/core.module";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { environment } from "@env";

import { ContentLayoutComponent } from "@layout/content-layout/content-layout.component";
import { FocusedLayoutComponent } from "@layout/focused/focused.component";
import { TopNavComponent } from "@layout/top-nav/top-nav.component";
import { ToastListComponent } from "@layout/toast-list/toast-list.component";

import { SharedModule } from "@shared/shared.module";
import { ErrorModule } from "@modules/error/error.module";

import { Angulartics2Module } from "angulartics2";

@NgModule({
  declarations: [
    // Base
    AppComponent,

    // Layouts
    ContentLayoutComponent,
    FocusedLayoutComponent,
    TopNavComponent,
    ToastListComponent,
  ],
  imports: [
    // Angular
    BrowserModule,

    // Routing
    AppRoutingModule,

    // App
    CoreModule,
    SharedModule,
    ErrorModule,

    // Analytics
    Angulartics2Module.forRoot(
      {
        gst: {
          trackingIds: [environment.googleAnalyticsID]
        }
      }
    ),
  ],
  providers: [ ],
  bootstrap: [
    AppComponent
  ],
  exports: [
    CoreModule,
  ]
})
export class AppModule { }
